// extracted by mini-css-extract-plugin
export default {"main-popup__tabs":"e1o9R","main-popup__description":"Uk62d","main-popup__title":"eGcho","main-popup__picture":"M4oBq"};